import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ConfirmDialogView from 'components/confirm-dialog-view';
import {stopEvent} from 'lib/utility-functions';
import {uiRemoveConfirmDialog, uiConfirmDialog} from 'modules/ui-module';
import environment from 'lib/environment';

export class ConfirmDialogContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      secondsRemaining: 20,
    };
  }

  componentDidMount() {
    if (
      this.props.confirmDialog.textResourceId &&
      ((this.props.confirmDialog.yesCallbackFn &&
      this.props.confirmDialog.noCallbackFn) ||
      (this.props.confirmDialog.useCountDownTimer))
    ) {
      this.openModal();
      if(this.props.confirmDialog.useCountDownTimer) {
        const nIntervalId = setInterval(() => {
          let {secondsRemaining} = this.state;
          secondsRemaining--;
          if(secondsRemaining >= 0) {
            this.setState({secondsRemaining});
          } else {
            clearInterval(nIntervalId);
            this.redirectToMyAccount();
          }
        }, 1000);
      }
    }
  }

  openModal = (e) => {
    stopEvent(e);
    this.setState({modalIsOpen: true});
  };

  closeModal = (e) => {
    stopEvent(e);
    this.setState({modalIsOpen: false},
      () => {
        this.props.uiRemoveConfirmDialog();
      });
  };

  redirectToMyAccount = () => {
    this.closeModal();
    location.href = environment.get().myAccount_url;
  };

  closeConfirmModalYesFn = (e) => {
    stopEvent(e);
    this.setState({modalIsOpen: false},
      () => {
        this.props.confirmDialog.yesCallbackFn();
        this.props.uiRemoveConfirmDialog();
    });
  };

  closeConfirmModalNoFn = (e) => {
    stopEvent(e);
    this.setState({modalIsOpen: false},
      () => {
        this.props.confirmDialog.noCallbackFn();
        this.props.uiRemoveConfirmDialog();
    });
  };

  render() {
    return (
      <div>
        <ConfirmDialogView
          closeModal={this.closeModal}
          textResourceId={this.props.confirmDialog.textResourceId}
          closeConfirmModalYesFn={this.closeConfirmModalYesFn}
          closeConfirmModalNoFn={this.closeConfirmModalNoFn}
          modalIsOpen={this.state.modalIsOpen}
          translationParams={this.props.confirmDialog.dialogParams || {}}
          useCountDownTimer={this.props.confirmDialog.useCountDownTimer}
          secondsRemaining={this.state.secondsRemaining}
        />
      </div>
    );
  }
}

ConfirmDialogContainer.propTypes = {
  uiRemoveConfirmDialog: PropTypes.func.isRequired,
  confirmDialog: PropTypes.shape({
    textResourceId: PropTypes.string,
    yesCallbackFn: PropTypes.func,
    noCallbackFn: PropTypes.func,
    dialogParams: PropTypes.object,
    useCountDownTimer: PropTypes.bool,
  })
};

export const mapStateToProps = (state) => {
  return {
    confirmDialog: uiConfirmDialog(state)
  };
};

export const mapDispatchToProps = (dispatch) => ({
  uiRemoveConfirmDialog: () => dispatch(uiRemoveConfirmDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialogContainer);
